import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { reflection, background } from './sierras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/230124/INEOS_Britannia/sierras-le_ineosbritannia_{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'none',
  }),
}
